// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jDHr","comment":"styles_comment__1n22R"};